var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodEntrepreneurDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 4.16655C4.8756 4.16593 3.94688 4.49526 3.2035 5.09912C2.46012 5.70299 1.94746 6.54451 1.75181 7.48205C1.55616 8.41959 1.68947 9.39592 2.1293 10.2467C2.56912 11.0975 3.28861 11.7708 4.16667 12.1532V14.3749H15.8333V12.1532C16.7594 11.7491 17.5071 11.0223 17.9374 10.108C18.3676 9.19376 18.451 8.15434 18.1721 7.18318C17.8932 6.21202 17.2709 5.37527 16.4211 4.82863C15.5713 4.28198 14.5519 4.06269 13.5525 4.21155C13.3005 3.46932 12.8223 2.82465 12.1852 2.36809C11.548 1.91153 10.7839 1.66602 10 1.66602C9.21615 1.66602 8.45199 1.91153 7.81483 2.36809C7.17766 2.82465 6.6995 3.46932 6.4475 4.21155C6.24417 4.18142 6.03889 4.16638 5.83334 4.16655ZM15.8317 15.6249H4.16834C4.17667 16.7891 4.23584 17.4266 4.655 17.8449C5.14334 18.3332 5.92834 18.3332 7.5 18.3332H12.5C14.0717 18.3332 14.8567 18.3332 15.345 17.8449C15.7642 17.4266 15.8233 16.7891 15.8317 15.6249Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodEntrepreneurDark);
export default __webpack_public_path__ + "static/media/FoodEntrepreneurDark.4cb8e1418031550718533d5ae34a5511.svg";
export { ForwardRef as ReactComponent };